import { api } from "./api";

const API_BASE = `${import.meta.env.VITE_API_URL}/api/v1`;

export const referralServices = {
  generate: () => {
    return api.post(`${API_BASE}/referral/generate`);
  },

  getMyCode: () => {
    return api.get(`${API_BASE}/referral/my-code`);
  },

  deactivate: () => {
    return api.patch(`${API_BASE}/referral/deactivate`);
  },

  activate: () => {
    return api.patch(`${API_BASE}/referral/activate`);
  },

  getShareMessage: () => {
    return api.get(`${API_BASE}/referral/share-message`);
  },

  getMyReferrals: () => {
    return api.get(`${API_BASE}/referral/my-referrals`);
  },

  validate: (referralCode) => {
    return api.post(`${API_BASE}/referral/validate`, {
      referral_code: referralCode,
    });
  },
};
